import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import { getStakeData } from '@/api/index'
import { remainDecimalByBN, formatWithRegex } from '@/utils/index'
import { useGenerateRefAndState } from "@/utils/useHooks";
import Header, { NavList } from "@/components/Base/header";
import Contact from "@/components/Base/contact";
import Footer from "@/components/Base/footer";
import Subscribe from "@/components/Base/subscribe";
import Overview from '@/static/images/overview.png'
import DmailLogo from '@/static/images/dmail-red.png'
import P1 from '@/static/images/stake-p1.png'
import P2 from '@/static/images/stake-p2-2.png'
import SkaleLogin from '@/static/images/airdrop/skale-logo.png'
import SkaleLogin2 from '@/static/images/airdrop/skale-logo2.png'
import SubHub from '@/static/images/airdrop/sub-hub.png'
import Dmail from '@/static/images/airdrop/dmail.png'
import Sub from '@/static/images/airdrop/sub.png'
import Bnb from '@/static/images/airdrop/bnb.png'
import Ok from '@/static/images/airdrop/ok.png'
import Coinbase from '@/static/images/airdrop/coinbase.png'
import SvgsCommons from "@/components/svgs/commons";
import SvgsSubscription from "@/components/svgs/subscription";
import { Root } from './css'

const StakeTimes = [
  {
    name: 'Early',
    svg: 'rush',
    svgWidth: 16,
    svgHeight: 14,
    time: 'June 15 - June 30',
    tip: 'Ended',
  },
  {
    name: 'Formal',
    svg: 'formal',
    svgWidth: 14,
    svgHeight: 14,
    time: 'July 1 - long term',
    tip: 'Not started',
  },
]

const FormalTypes = [
  {
    days: '30',
    apr: '7',
    points: '2.7',
  },
  {
    days: '90',
    apr: '15',
    points: '6.3',
  },
  {
    days: '360',
    apr: '30',
    points: '10.8',
  },
]
const StakeTypes = [
  [
    {
      days: '30',
      apr: '8',
      oriApr: FormalTypes[0].apr,
      points: '3',
      oriPoints: FormalTypes[0].points,
    },
    {
      days: '90',
      apr: '17',
      oriApr: FormalTypes[1].apr,
      points: '7',
      oriPoints: FormalTypes[1].points,
    },
    {
      days: '360',
      apr: '33',
      oriApr: FormalTypes[2].apr,
      points: '12',
      oriPoints: FormalTypes[2].points,
    },
  ],
  FormalTypes,
]

// const QAList = [
//   {
//     q: '1. Which networks support $DMAIL staking?',
//     a: 'Currently $DMAIL staking on the BNB Chain and Ethereum networks are supported, and the stake rules are the same as those for rewards.',
//   },
//   {
//     q: '2. What is the difference between Early staking and Formal Staking?',
//     a: 'Early staking will result in a higher APR and point-weighted rewards.',
//   },
//   {
//     q: '3. What are weighted points and how do I receive them?',
//     a: (
//         <div>
//           <p>Weighted Points are a one-time bonus of Dmail Points for stakers. The amount allocated is determined by the amount of stake X the weighted value.</p>
//           <p>After successfully staking, the bonus points will be added to the stake account in real time and you can check it at <a href="https://mail.dmail.ai/events/points." target="_blank">https://mail.dmail.ai/events/points</a>.</p>
//       </div>
//     ),
//   },
//   {
//     q: '4. Can you redeem the stake in advance?',
//     a: "No, you can't redeem the stake in advance.",
//   },
//   {
//     q: '5. How do I receive my rewards?',
//     a: "After the staking period expires, you can click 'claim' in the 'My Stake' list to claim your reward.",
//   },
// ]

const defaultData = {
  price: '--',
  staked: '--',
  rewards: '--',
}
const Index = ({ store }) => {
  const history = useHistory();
  const { isMobile } = store.common;

  const [data, setData] = useState({ ...defaultData })
  const [currentPeriod, setCurrentPeriod] = useState(0)
  const [index, setIndex] = useState(0)
  useEffect(() => {
    setIndex(currentPeriod)
  }, [currentPeriod])

  // const [qaList, setQaList, qaListRef] = useGenerateRefAndState([...QAList])
  // const qaListDomRef = useRef(null)
  // const expandQa = (index) => () => {
  //   if (qaListRef.current[index]) {
  //     const _qaList = [...qaListRef.current]
  //     _qaList[index] = {
  //       ..._qaList[index],
  //       height: _qaList[index].height === 0 ? _qaList[index].oriHeight : 0,
  //     }
  //     // console.log('_qaList', _qaList)
  //     setQaList(_qaList)
  //   }
  // }

  const toStake = (jump = false) => () => {
    jump && window.open('https://mail.dmail.ai/stake')
  }

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (qaListDomRef.current) {
  //       const domLis = qaListDomRef.current.querySelectorAll('li .answer')
  //       if (domLis.length) {
  //         setQaList(QAList.map((item, index) => ({
  //           ...item,
  //           height: index === 0 && domLis[0] ? domLis[0].clientHeight : 0,
  //           oriHeight: domLis[index] ? domLis[index].clientHeight : 'auto',
  //         })))
  //       }
  //     }
  //   }, 300);
  // }, [])

  useEffect(() => {
    const fn = async () => {
      const data = await getStakeData()
      setData({ ...defaultData, ...data })
      setCurrentPeriod(data.period || 0)
    }
    fn()
  }, [])

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header className={'black-header'} currentName="stake" />
      <div className="content">
        {isMobile ? (
          <h1>Earn up to 12x Dmail Points & <br /> Ecosystem Airdrops</h1>
        ): (
          <h1>Earn up to 12x Dmail Points & Ecosystem Airdrops</h1>
        )}
        <h2>
          By
          <strong onClick={toStake(true)}>Staking</strong>
          $DMAIL
        </h2>
        <div className="desc">Lock your $DMAIL now to maximize your points total before more season airdrops!</div>
        <div className="center">
          <div className="total-staked">
            <h3>Total $DMAIL Staked</h3>
            <div className="staked-num"><img src={DmailLogo} width={isMobile ? 20 : 45} />{data.staked > 0 ? formatWithRegex(remainDecimalByBN(data.staked)) : '--'}</div>
          </div>
          {/* <div className="overview">
            <h3><strong>$DMAIL</strong>OVERVIEW<img src={Overview} /></h3>
            <div className="stake-info">
              <ul>
                <li>
                  <div>{data.price}</div>
                  <p>$DMAIL Price</p>
                </li>
                <li>
                  <div><img src={DmailLogo} width={isMobile ? 20 : 40} />{data.staked}</div>
                  <p>Total Staked</p>
                </li>
                <li>
                  <div><img src={DmailLogo} width={isMobile ? 20 : 40} />{data.rewards}</div>
                  <p>Total Rewards</p>
                </li>
              </ul>
            </div>
          </div> */}

          <div className="stake-rewards">
            <div className="title">🎉 Earn up to 12x points rewards for staking $DMAIL tokens!</div>
            <div className="table">
              <div className="tr">
                <div className="td">Duration</div>
                <div className="td">Flexible</div>
                <div className="td">7 days</div>
                <div className="td">30 days</div>
                <div className="td">90 days</div>
              </div>
              <div className="tr">
                <div className="td">Dmail Points {isMobile ? null : <div className='tips'><SvgsCommons type="question" /><p>Dmail Points Reward = The Amount of Staked $DMAIL x Ratio(0.8, 2.4, etc.)</p></div>}</div>
                <div className="td"><strong>0.8x</strong></div>
                <div className="td"><strong>2.4x</strong></div>
                <div className="td"><strong>8x</strong></div>
                <div className="td"><strong>12x</strong></div>
              </div>
              <div className="tr">
                <div className="td">Ecosystem Airdrops</div>
                <div className="td"><div>$DMAIL stakers may be eligible for 🎁 airdrops from partners within the Dmail ecosystem.</div></div>
              </div>
            </div>
            <div className="actions">
              <div className={["btn", "filled-red"].join(' ')} onClick={toStake(true)}>
                Stake $DMAIL Now
              </div>
              <a className="buy" href='https://www.gate.io/trade/DMAIL_USDT' target='_blank'><SvgsCommons type="shoppingCar" width={isMobile ? 17 : 28} height={isMobile ? 14 : 22} /><span>Get $DMAIL</span></a>
            </div>
          </div>

          <div className="common airdrops">
            <h3>Ecosystem Airdrops</h3>
            {/* <div className="airdop-item sub-hub">
              <div className="airdrop-info">
                <div className="detail">
                  <SvgsSubscription type="logo" width={isMobile ? 50 : 65} />
                  <div>
                    <strong>Subscription & Notification</strong>
                    <span>Web3</span>
                    <span>AI</span>
                    <span>Infrastructure</span>
                    <span>Notifications</span>
                  </div>
                </div>
                <div className="desc">
                Subscription & Notification is an enterprise-level platform for developers, aggregating information, marketing notification and offering refined operational services.
                </div>
                <div className="more-info">
                  <div className="item">
                    <p>Markets</p>
                    <div>-- --</div>
                  </div>
                  <div className="item">
                    <p>Snapshot Time</p>
                    <div>TBD</div>
                  </div>
                  <div className="item">
                    <p>Claim End Time</p>
                    <div>-- --</div>
                  </div>
                </div>
              </div>
              <div className="tokens mult-tokens">
                <div className="tokens-thumb">
                  <img src={Dmail} width={isMobile ? 24 : 35} alt="" />
                  <SvgsSubscription type="logo" width={isMobile ? 22 : 33} />
                </div>
                <p>500K $DMAIL &nbsp; + &nbsp; 2M $SUBHUB</p>
              </div>
            </div> */}
            <div className="airdop-item">
              <div className="airdrop-info">
                <div className="detail">
                  <img src={SkaleLogin} width={isMobile ? 50 : 65} alt="" />
                  <div>
                    <strong>SKALE</strong>
                    <span>Defi</span>
                    <span>Web3</span>
                    <span>Metaverse</span>
                    <span>Layer 2</span>
                  </div>
                </div>
                <div className="desc">
                The gas-free, EVM-compatible, modular AppChain network. BUILT DIFFERENT to scale gaming, AI, and high-performance dApps to the masses. Born in Cali.
                </div>
                <div className="more-info">
                  <div className="item">
                    <p>Markets</p>
                    <div>
                      <img src={Bnb} width={isMobile ? 16 : 24} alt="" />
                      <img src={Coinbase} width={isMobile ? 16 : 24} alt="" />
                      <img src={Ok} width={isMobile ? 16 : 24} alt="" />
                      <span>...</span>
                    </div>
                  </div>
                  <div className="item">
                    <p>Snapshot Time</p>
                    <div>2024/10/31 8:00 GMT+08:00</div>
                  </div>
                  <div className="item">
                    <p>Claim End Time</p>
                    <div>2024/11/03 (Automatic Distribution)</div>
                  </div>
                </div>
              </div>
              <div className="tokens">
                <img src={SkaleLogin2} width={isMobile ? 24 : 35} alt="" />
                <p>500,000 SKL</p>
              </div>
              <div className="ended"><span>Ended</span></div>
            </div>
          </div>

          <div className="common partners">
            <h3>Ecosystem Partners</h3>
            <ul>
              <li><img src={P1} alt="" /></li>
              <li><img src={P2} alt="" /></li>
            </ul>
            <div className="more">✨ More partners are coming soon!</div>
          </div>

          {/* <div className="faq">
            <h3>FAQs</h3>
            <ul ref={qaListDomRef}>
              {qaList.map(({ q, a, height }, index) => (
                <li onClick={expandQa(index)} key={index}>
                  <div className={["question", height === 0 ? 'expand' : 'narrow'].join(' ')}>
                    {q}
                    <i></i>
                  </div>
                  <div className="answer" style={{ height }}>{ a }</div>
                </li>
              ))}
            </ul>
          </div> */}
        </div>
      </div>
      <div className="bottom">
        <div className="center">
          <Contact />
          <Footer />
        </div>
      </div>
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))